import { render, staticRenderFns } from "./twoPage.vue?vue&type=template&id=842e9f90&scoped=true&"
import script from "./twoPage.vue?vue&type=script&lang=js&"
export * from "./twoPage.vue?vue&type=script&lang=js&"
import style0 from "./twoPage.vue?vue&type=style&index=0&id=842e9f90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842e9f90",
  null
  
)

export default component.exports